import { Typography, type TypographyOwnProps } from '@mui/material';
import Box from '@mui/material/Box';

type ExtendedTypographyParams = TypographyOwnProps & {
  search?: string;
  text: string;
};

export function HighlightedTypography({
  search,
  text,
  ...props
}: ExtendedTypographyParams) {
  if (!search) return <Typography {...props}>{text}</Typography>;

  const parts = text.split(new RegExp(`(${search})`, 'gi'));

  return (
    <Typography {...props}>
      {parts.map((part, index) =>
        part.match(new RegExp(search, 'gi')) ? (
          <Box
            sx={(theme) => ({
              backgroundColor: theme.palette.info.light,
              ...theme.applyStyles('dark', {
                color: '#000000',
              }),
            })}
            component={'mark'}
            key={index}
          >
            {part}
          </Box>
        ) : (
          part
        )
      )}
    </Typography>
  );
}
